import { fmtUsdAmount } from './termSheetFormatters';

const COSTS_AND_EXPENSES_OWN_COSTS_PARAGRAPH =
  'Each party shall be liable for its own costs and expenses (including, without limitation, legal and out-of-pocket expenses) incurred in connection with the proposed transaction, including the negotiation, preparation, and execution of any document relating thereto.';

const COSTS_AND_EXPENSES_COMPANY_PAYS_PREFIX =
  'Notwithstanding the above, the Company shall promptly on demand pay to Treisar the amount of all costs and expenses (including, without limitation, legal and out-of-pocket expenses) incurred by Treisar in connection with the proposed transaction, including the negotiation, preparation, and execution of any document relating thereto';

function isFilledAmount(value) {
  if (value === '' || value == null) {
    return false;
  }
  return Number.isFinite(Number(value));
}

export function buildCostsAndExpensesClause(fields, formatAmount = fmtUsdAmount) {
  let companyPays = COSTS_AND_EXPENSES_COMPANY_PAYS_PREFIX;
  if (isFilledAmount(fields.costsAndExpensesMaxCharges)) {
    const amount = formatAmount(fields.costsAndExpensesMaxCharges);
    companyPays += `, provided that the Company shall not be liable for such amounts exceeding US $${amount}`;
  }
  companyPays += '.';
  if (isFilledAmount(fields.costsAndExpensesUpfrontFee)) {
    const amount = formatAmount(fields.costsAndExpensesUpfrontFee);
    companyPays += ` In addition and without prejudice to the foregoing, the Company shall pay to Treisar an upfront fee of US $${amount} upon signing of this Term Sheet, which amount shall be applied against the amount of the aforementioned costs and expenses.`;
  }
  return `${COSTS_AND_EXPENSES_OWN_COSTS_PARAGRAPH}\n\n${companyPays}`;
}

export const DEFAULT_COSTS_AND_EXPENSES_WORDING = buildCostsAndExpensesClause({
  costsAndExpensesMaxCharges: '',
  costsAndExpensesUpfrontFee: '',
});
